import React, { useEffect } from 'react';

const TermsConditions = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="min-h-screen pt-24 pb-12 bg-gradient-to-br from-gray-900 via-black to-gray-900">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
        <h1 className="text-4xl sm:text-5xl font-bold text-white mb-8 text-center">Terms & Conditions</h1>
        
        <div className="bg-gradient-to-br from-gray-800 to-gray-900 rounded-2xl p-6 sm:p-8 shadow-lg shadow-purple-900/30 border border-purple-500/20">
          <div className="space-y-6 text-gray-300">
            <div>
              <p className="text-gray-400 text-sm mb-6">Last Updated: January 2026</p>
              <p className="text-base leading-relaxed mb-4">
                Welcome to Invotage. These Terms and Conditions ("Terms") govern your use of our website and services. By accessing or using our services, you agree to be bound by these Terms.
              </p>
            </div>

            <div>
              <h2 className="text-2xl font-bold text-white mb-3">1. Services</h2>
              <p className="text-base leading-relaxed mb-3">
                Invotage provides digital solutions including but not limited to:
              </p>
              <ul className="list-disc list-inside space-y-2 ml-4 text-base">
                <li>Web development and design</li>
                <li>Mobile application development</li>
                <li>Custom software development</li>
                <li>E-commerce solutions</li>
                <li>Blockchain integration</li>
                <li>UI/UX design services</li>
                <li>3D animation and visualization</li>
                <li>Cloud infrastructure solutions</li>
                <li>Digital marketing services</li>
                <li>Professional copywriting</li>
              </ul>
            </div>

            <div>
              <h2 className="text-2xl font-bold text-white mb-3">2. Client Responsibilities</h2>
              <p className="text-base leading-relaxed mb-3">
                As a client, you agree to:
              </p>
              <ul className="list-disc list-inside space-y-2 ml-4 text-base">
                <li>Provide accurate and complete information</li>
                <li>Respond to requests for information in a timely manner</li>
                <li>Review and approve deliverables within agreed timeframes</li>
                <li>Make payments according to the agreed schedule</li>
                <li>Provide necessary access to systems and resources</li>
                <li>Respect intellectual property rights</li>
              </ul>
            </div>

            <div>
              <h2 className="text-2xl font-bold text-white mb-3">3. Payment Terms</h2>
              <p className="text-base leading-relaxed mb-3">
                Payment terms include:
              </p>
              <ul className="list-disc list-inside space-y-2 ml-4 text-base">
                <li>Payment schedules will be outlined in individual project agreements</li>
                <li>Invoices are due within 15 days of receipt unless otherwise specified</li>
                <li>Late payments may incur interest charges</li>
                <li>Work may be suspended for non-payment</li>
                <li>All fees are non-refundable unless otherwise stated</li>
              </ul>
            </div>

            <div>
              <h2 className="text-2xl font-bold text-white mb-3">4. Intellectual Property</h2>
              <p className="text-base leading-relaxed mb-3">
                Upon full payment for services:
              </p>
              <ul className="list-disc list-inside space-y-2 ml-4 text-base">
                <li>Clients receive ownership of custom-developed deliverables</li>
                <li>Invotage retains rights to pre-existing tools, frameworks, and methodologies</li>
                <li>Third-party components remain subject to their respective licenses</li>
                <li>Invotage may showcase completed work in portfolios unless otherwise agreed</li>
              </ul>
            </div>

            <div>
              <h2 className="text-2xl font-bold text-white mb-3">5. Project Timeline</h2>
              <p className="text-base leading-relaxed">
                Project timelines are estimates and may be subject to change based on project scope modifications, client feedback cycles, and unforeseen technical challenges. We will communicate any timeline changes promptly.
              </p>
            </div>

            <div>
              <h2 className="text-2xl font-bold text-white mb-3">6. Warranties and Disclaimers</h2>
              <p className="text-base leading-relaxed mb-3">
                We warrant that:
              </p>
              <ul className="list-disc list-inside space-y-2 ml-4 text-base">
                <li>Services will be performed with reasonable skill and care</li>
                <li>Deliverables will substantially conform to agreed specifications</li>
                <li>We will rectify defects reported within the warranty period</li>
              </ul>
              <p className="text-base leading-relaxed mt-3">
                Services are provided "as is" without any other warranties, express or implied.
              </p>
            </div>

            <div>
              <h2 className="text-2xl font-bold text-white mb-3">7. Limitation of Liability</h2>
              <p className="text-base leading-relaxed">
                Invotage's liability is limited to the total amount paid for the specific service giving rise to the claim. We are not liable for indirect, incidental, special, consequential, or punitive damages.
              </p>
            </div>

            <div>
              <h2 className="text-2xl font-bold text-white mb-3">8. Confidentiality</h2>
              <p className="text-base leading-relaxed">
                Both parties agree to maintain the confidentiality of proprietary information shared during the course of the engagement. This obligation continues beyond the termination of services.
              </p>
            </div>

            <div>
              <h2 className="text-2xl font-bold text-white mb-3">9. Termination</h2>
              <p className="text-base leading-relaxed mb-3">
                Either party may terminate services with written notice. Upon termination:
              </p>
              <ul className="list-disc list-inside space-y-2 ml-4 text-base">
                <li>Client remains responsible for payment of work completed</li>
                <li>Invotage will deliver work completed to date</li>
                <li>Intellectual property rights transfer only for fully paid work</li>
              </ul>
            </div>

            <div>
              <h2 className="text-2xl font-bold text-white mb-3">10. Dispute Resolution</h2>
              <p className="text-base leading-relaxed">
                Any disputes arising from these Terms will be resolved through good faith negotiation. If negotiation fails, disputes will be settled through binding arbitration in Los Angeles, California.
              </p>
            </div>

            <div>
              <h2 className="text-2xl font-bold text-white mb-3">11. Governing Law</h2>
              <p className="text-base leading-relaxed">
                These Terms are governed by the laws of the State of California, United States, without regard to its conflict of law provisions.
              </p>
            </div>

            <div>
              <h2 className="text-2xl font-bold text-white mb-3">12. Changes to Terms</h2>
              <p className="text-base leading-relaxed">
                We reserve the right to modify these Terms at any time. Changes will be effective immediately upon posting to our website. Your continued use of our services constitutes acceptance of modified Terms.
              </p>
            </div>

            <div>
              <h2 className="text-2xl font-bold text-white mb-3">13. Contact Information</h2>
              <p className="text-base leading-relaxed">
                For questions about these Terms and Conditions, please contact us at:
              </p>
              <div className="mt-4 p-4 bg-gray-900/50 rounded-lg border border-purple-500/20">
                <p className="text-base"><strong className="text-white">Invotage LLC</strong></p>
                <p className="text-base">11040 Santa Monica Blvd #310</p>
                <p className="text-base">Los Angeles, CA 90025</p>
                <p className="text-base mt-2">Email: info@invotage.com</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default TermsConditions;
